export const ParentsReviews = [
  {
    reviewTitle: " Professional Approach",
    location: "Hyderabad,India",
    name: "Aniruddha Banik",
    image: "parent-1-m.svg",
    content:
      "I got instant response upon my queries. They had provided very experienced and good tutor for my 12 years old son who is in CBSE board. Happy yo share that they are excellent in service commitment , Thank you Home Shiksha for supporting parents like us who need good home tutor",
  },
  {
    reviewTitle: " Very Good Personal Tutor",
    location: "Mumbai,India",
    name: "KanchyKanz",
    image: "parent-2-m.svg",
    content:
      "Really very happy with this institution as I could get a very good personal tutor for my daughter. Prashanthini has been very good and we could see a difference within a month in our daughter's learning curve. All thanks to Prashanthini who treats our daughter as her own.",
  },
  {
    reviewTitle: " Great platform",
    location: "Mumbai,India",
    image: "parent-3-m.svg",
    name: "Rahul Chavan",
    content:
      "Home Shiksha provides great, and useful platform in educational field. I have been grateful to them for arranging tutors, and classes as per our kids requirements.",
  },
  {
    reviewTitle: " Long Lasting Relationship",
    location: "Bangalore,India",
    name: "Rachel Poovaiah",
    image: "parent-4-f.svg",
    content:
      "Homeshiksha has been proactive in providing quality teachers in a short span of time.They have coordinated well to understand my needs. Looking forward to have a long lasting relationship with them.",
  },
  {
    reviewTitle: " Long Lasting Relationship",
    location: "Bangalore,India",
    name: "Rachel Poovaiah",
    image: "parent-5-m.svg",
    content:
      "Homeshiksha has been proactive in providing quality teachers in a short span of time.They have coordinated well to understand my needs. Looking forward to have a long lasting relationship with them.",
  },
  {
    reviewTitle: " Friendly Staff",
    location: "Hyderabad,India",
    name: "Sowjanya Balireddy",
    image: "parent-6-f.svg",
    content:
      "Very good institute and friendly staff. We recently hired a shadow teacher from Home shiksha and she has very good knowledge and idea about what she need to work on based on the child needs and requirements. Based on that she stated working on it… which is really good. Thanks home shiksha.. 👍",
  },
  {
    reviewTitle: " Professional Services",
    location: "Bangalore,India",
    name: "Dassan Gita",
    image: "parent-7-f.svg",
    content:
      "I had contacted Homesiksha for shadow teacher requirement for mychild 6 years.She was very professional.I found Homesiksha services very professional. Have recommended their services to my friends aswell.",
  },
  {
    reviewTitle: " Excellent Tuitions",
    location: "Bangalore,India",
    name: "Fathima",
    image: "parent-8-f.svg",
    content:
      "Homeshiksha has connected me to some excellent tuitions which take into consideration the requirements and convenience of both the students, as well as the tutors. 10/10",
  },
  {
    reviewTitle: " Best platform",
    location: "Hyderabad,India",
    name: "Sravanthivd",
    image: "parent-9-f.svg",
    content:
      "I looked for shadow teacher service..They give the options for us to choose the best for our requirement...Overall the service is good as of now.",
  },
  {
    reviewTitle: " Good Support",
    location: "Hyderabad,India",
    name: "Sindhuja",
    image: "parent-10-f.svg",
    content:
      "Home siksha has given me a very good support by searching a qualified teacher who Can match my requirements. They have shown enough patience. Thank you for that # it depends on the teacher though.",
  },
  {
    reviewTitle: " Response Quick",
    location: "Mumbai,India",
    name: "Sheena Mehta",
    image: "parent-11-f.svg",
    content:
      "After shifting to Mumbai and duped by so many private agencies I gave one last shot by contacting Home shiksha. Response time was quick, very professional, polite and humble. I have finally got two tutors from them and will soon be getting one more for my daughter.. Thankyou Homeshiksha.",
  },
  {
    reviewTitle: " Very Responsible",
    location: "Hyderabad,India",
    name: "Radhika Tatiyal",
    image: "parent-12-f.svg",
    content:
      "I got in touch with Home Shiksha for a teacher and the response by Divya was always prompt. Would highly recommend Home Shiksha to anybody looking for good tutors.",
  },
  {
    reviewTitle: " Very Organised",
    location: "Bangalore,India",
    name: "Geetha Sridhara",
    image: "parent-13-f.svg",
    content:
      "I got to know about HomeShiksha from a parent and I thought of giving a try for my kid's tuition. It's very organised and they gave 3 teachers for demo and I chose the best amongst the three.We get good quality learning experience at our home as per our convenient time.",
  },
  {
    reviewTitle: " Being So Reliable",
    location: "Hyderabad,India",
    name: "Gautham Kapoor",
    image: "parent-15-m.svg",
    content:
      "HomeShiksha is a superb platform to learn. I am doing MBA Finance with no commerce/ economics background. So Home Shiksha has been my go to place for past one year to seek great tutors who are guiding me through subjects unfamiliar to me. Thanks for being so reliable",
  },
];
